export default __webpack_public_path__ + "static/media/Group9414.0a18057c.svg";